import {Link, useLocation} from "react-router-dom";
import React, {useEffect, useMemo, useState} from "react";
import {EditLocalStoragePagesData} from "../../../utils/EditLocalStoragePagesData";
import ModuleController from "../../../API/organization/ModuleController";
import ModulesTable from "./ModulesTable";
import {withFilter} from "../../../data/FilterTables/withFilterHOC";
import {ModulesFilterData} from "../../../data/FilterTables/ModulesFilterData";

const Modules = ({itemId, handleModalAlert}) => {
    const ComponentModulesWithFilter = useMemo(() => {
        return withFilter(ModulesTable, ModulesFilterData);
    }, []);
    const pathname = useLocation().pathname
    const [data, setData] = useState([]);
    const [tableOptions, setTableOptions] = useState({
        pageIndex: 0,
        pageSize: 100,
        totalElements: 0,
        searchData: ""
    })

    useEffect(() => {
        getStartPageSize()
        ModuleController.get().then(function (response) {
            setData(response.data);
            setTableOptions((prev) => ({...prev, totalElements: response?.data.length}))
        })
            .catch(function (error) {
                handleModalAlert(error);
            });
    }, []);

    const tableOptionsHandle = (nextState) => {
        setTableOptions(nextState)
        if (nextState.pageSize !== tableOptions.pageSize) {
            EditLocalStoragePagesData(`${pathname}+${itemId}`, "pageSize", nextState.pageSize)
        }
    }

    const getStartPageSize = () => {
        const pagesData = JSON.parse(localStorage.getItem('pagesData')) || {}
        const pageSize = pagesData[`${pathname}+${itemId}`]?.pageSize
        pageSize && setTableOptions((prev) => ({...prev, pageSize: pageSize}))
    }

    return <ComponentModulesWithFilter
        handleModalAlert={handleModalAlert}
        tableOptions={tableOptions}
        tableOptionsHandle={tableOptionsHandle}
        data={data}
        setData={setData}/>
};

export default Modules;